import apiClient from "../../../api/apiClient";

/**
 * Fetch customers with optional search query
 */
export const fetchCustomers = async ({ search }) => {
  try {
    const response = await apiClient.get(`/customers?search=${search}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw new Error("Failed to fetch customers.");
  }
};

/**
 * Fetch a single customer by ID
 */
export const fetchCustomerById = async (customerId) => {
  try {
    const response = await apiClient.get(`/customers/${customerId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching customer ${customerId}:`, error);
    throw new Error(`Failed to fetch customer ${customerId}.`);
  }
};

/**
 * Update a customer
 */
export const updateCustomer = async (customerId, customerData) => {
  try {
    const response = await apiClient.put(`/customers/${customerId}`, customerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating customer ${customerId}:`, error);
    throw new Error(`Failed to update customer ${customerId}.`);
  }
};

/**
 * Delete a customer
 */
export const deleteCustomer = async (customerId) => {
  try {
    await apiClient.delete(`/customers/${customerId}`);
    return { message: "Customer deleted successfully" };
  } catch (error) {
    console.error(`Error deleting customer ${customerId}:`, error);
    throw new Error(`Failed to delete customer ${customerId}.`);
  }
};